<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Members</h4>
            </div>
          <h6 class="card-title">Segments</h6>
            <el-badge :value="segment.member_count" class="item" v-for="segment in segments">
              <el-button size="small">  {{segment.name}}</el-button> <br/>
            </el-badge>
             
          
            <data-tables-server
              class="table-shopping"
              style="width: 100%"
              :data="members"
              :tool-bar="false"
              :total="total"
              :page-size="2"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
            >
              <el-table-column min-width="50" label="Email" prop="email_address">
                <template slot-scope="props">
                  <span>{{props.row.email_address}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Firstname" prop="firstname">
                <template slot-scope="props">
                  <span>{{props.row.merge_fields.FNAME}} {{props.row.merge_fields.LNAME}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Request Brochure" prop="brochure">
                <template slot-scope="props">
                  <span>{{props.row.merge_fields.BRO_RDATE}}</span>
                </template>
              </el-table-column>
                <el-table-column min-width="50" label="View" prop="brochure">
                <template slot-scope="props">
                  <span> <router-link :to="'/mailchimp/edit/'+props.row.id">Edit</router-link></span>
                </template>
              </el-table-column>
            </data-tables-server>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
        segments:[],
      members: [],
      total: 0
    };
  },
  methods: {
    getMembers() {
      api
        .getMembers({
          count: 10,
          offset: 0,
          sort_field: "last_changed",
          sort_dir: "DESC",
          status:'subscribed'
        })
        .then(response => {
          this.members = response.data.members;
          this.total = response.data.total_items;
        });
    },
     getSegments() {
      api
        .getSegments()
        .then(response => {
          this.segments = response.data.segments;
         
        });
    }
  },

  async mounted() {
      this.getSegments();
    this.getMembers({ count: 10, offset: 0 });
  }
};
</script>
<style>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Mailchimp/List.vue